export const REGISTER_EMAIL_PT_BR = {
	registerEmail: "Cadastre um e-mail para continuar",
	cardInfo: `Enviaremos um link para autenticar este e-mail e, após isso, você poderá	acessar 
	normalmente com seu login e senha.`,
	description: "É rápido e será feito apenas uma vez.",
	enterprise: "Empresa",
	email: "E-mail",
	emailPlaceholder: "Digite seu e-mail",
	enterprisePlaceholder: "Digite sua empresa",
	login: "Login",
	password: "Senha",
	confirmPassword: "Confirmar senha",
	confirm: "Confirmar e enviar e-mail",
	send: "Enviar",
	backToLogin: "Voltar ao Login",
	sendEmailModal: {
		title: "O E-mail foi enviado!",
		subtitle1: "Enviamos um link para {{email}}",
		subtitle2: `Abra o e-mail e clique em 'Autenticar e-mail' para continuar 
			acessando o Dashboard.`,
	},
	emailConfirmedModal: {
		title: "O E-mail que você cadastrou foi autenticado!",
		subtitle:
			"Agora você poderá acessar o Dashboard Zig com seu Login e senha normalmente.",
		makeLogin: "Fazer login",
	},
	expiredLinkModal: {
		title: "Esse link foi expirado!",
		subtitle:
			"Insira novamente o e-mail para que um novo link de autentificação seja enviado.",
		registerEmail: "Cadastrar e-mail",
	},
	resendEmail: "Reenviar e-mail em ({{countDown}})",
	fields: {
		enterprise: {
			required: "O nome da empresa é requerido",
		},
		email: {
			required: "O e-mail é requerido",
			invalid: "Insira um e-mail válido",
		},
	},
};

export type RegisterEmailTranslations = typeof REGISTER_EMAIL_PT_BR;
